import {Link} from 'gatsby';
import React from 'react';
import {makeValidHref} from '../../../helpers';

const TechStackResult = (props: any) => (
  <div className="d-block mx-auto mt-4">
    {props.url && (
      <div className="d-flex m-auto pb-2" style={{maxWidth: '785px', width: '100%'}}>
        <div>
          <Link to="/tools/history/#tech-stack">← Back to history</Link>
        </div>
        <div className="ml-auto" style={{maxWidth: 'calc(100% - 150px)', whiteSpace: 'nowrap', display: 'flex'}}>
          <div className="mr-1">Result for</div>
          <a
            title={props.url}
            href={makeValidHref(props.url)}
            target="_blank"
            className="text-truncate"
            style={{width: 'calc(100% - 50px)', display: 'inline-block'}}
            rel="noopener"
          >
            {props.url}
          </a>
        </div>
      </div>
    )}
    <div className="col-12 tech-stack-result text-center m-auto">
      {props.result.length === 1 && props.result[0] === 'Not found.' ? (
        <h5 className="text-center">Page not found</h5>
      ) : (
        props.result &&
        props.result.map((item: any) => {
          if (!item) return;
          return (
            <div className="result-item text-center">
              <div className="img-wrapper mx-auto">
                <img src={require(`../../../../static/tech-stack-icons/${item.icon}`)} alt="tech-stack" />
              </div>
              <div className="name">{item.name}</div>
            </div>
          );
        })
      )}
    </div>
  </div>
);

export default TechStackResult;
